var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("REQUEST ACCESS")
      ]),
      _vm._v(" "),
      !_vm.clientRequest
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c(
                "form",
                {
                  attrs: { method: "post" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.requestClientAccess()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "clientHostname" } }, [
                      _vm._v("Hostname")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.clientHostname,
                          expression: "clientHostname"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "clientHostname" },
                      domProps: { value: _vm.clientHostname },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.clientHostname = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      staticClass: "btn btn-send form-control",
                      attrs: { type: "submit", value: "Verzenden" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.requestClientAccess()
                        }
                      }
                    })
                  ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientRequest &&
      !_vm.clientRequest.certificate.signed &&
      !_vm.clientRequestExpired
        ? _c("div", { staticClass: "col-lg-12 menu-item" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientRequest &&
      !_vm.clientRequest.certificate.signed &&
      _vm.clientRequestExpired
        ? _c("div", { staticClass: "col-lg-12 menu-item" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("p", [_vm._v("De aanvraag is verlopen.")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  staticClass: "btn btn-send form-control",
                  attrs: { type: "submit", value: "Verzenden" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.resetClientRequest()
                    }
                  }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientRequest && _vm.clientRequest.certificate.signed
        ? _c("div", { staticClass: "col-lg-12 menu-item" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn btn-pick btn-full-width",
                on: {
                  click: function($event) {
                    _vm.downloadCertificateChain()
                  }
                }
              },
              [
                _c("div", { staticClass: "btn-first-line" }, [
                  _vm._v("download")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-primary-line" }, [
                  _vm._v("CERTIFICATE CHAIN")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn btn-item-info btn-full-width",
                on: {
                  click: function($event) {
                    _vm.downloadPkcs12certificate()
                  }
                }
              },
              [
                _c("div", { staticClass: "btn-first-line" }, [
                  _vm._v("download")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-primary-line" }, [
                  _vm._v("PKCS 12 CERTIFICATE")
                ])
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product-info" }, [
      _c("p", [
        _vm._v(
          "Vraag een beheerder om de aanvraag te ondertekenen. De certificaten kunnen hier gedownload worden nadat de aanvraag is ondertekent."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "product-info" }, [
      _c("p", [
        _vm._v(
          "Download en installeer beide certificaten in de browser of in het besturingssysteem. Herstart na het installeren de browser."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38c5d5d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c5d5d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientAuthentication.vue
// module id = r8GP
// module chunks = 1